import React from 'react';
import cardBackground from '../../images/pristyn-care/cardBackground.png';

const Card = (props) => {
  return (
    <div
      className="border border-solid rounded-2xl p-1 flex flex-col"
      style={{
        borderColor: '#C8C8C8',
        width: '185px',
        height: '96px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <img
        src={cardBackground}
        alt="cardBackground"
        style={{
          position: 'absolute',
          top: '0px',
          left: '0px',
          zIndex: '-1',
        }}
      />
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            width: '45px',
            height: '37.29px',
            fontWeight: 600,
            fontSize: '23.1429px',
            lineHeight: '31px',
            color: '#0D2059',
            margin: '15px 40px 0px 0px',
          }}
        >
          {props.count}
        </p>
        <p
          style={{
            width: '45px',
            height: '37.29px',
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '23px',
            color: '#515151',
            margin: '-10px 40px 0px 0px',
          }}
        >
          {props.text}
        </p>
      </div>
    </div>
  );
};

export default Card;
